'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _debounce = require('lodash/debounce');var _debounce2 = _interopRequireDefault(_debounce);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _OMAutocompleteInput = require('../../OMComponents/OMAutocompleteInput/OMAutocompleteInput');var _OMAutocompleteInput2 = _interopRequireDefault(_OMAutocompleteInput);
var _googleService = require('../../../helpers/googleService');var _googleService2 = _interopRequireDefault(_googleService);
var _constants = require('../../../constants');
var _analyticsManager = require('../../../utils/analytics/analyticsManager');
var _checkers = require('../../../utils/checkers');
var _extractLocalisedData = require('../../../helpers/extractLocalisedData');var _extractLocalisedData2 = _interopRequireDefault(_extractLocalisedData);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

HomePageLocationInput = function (_Component) {_inherits(HomePageLocationInput, _Component);
  function HomePageLocationInput(props) {_classCallCheck(this, HomePageLocationInput);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.



    state = {
      suggestions: [],
      value: '',
      lastSearchHistory: [],
      autoFocus: true,
      geocodedValue: '' };_this.


    componentDidMount = function () {
      new _googleService2.default(_this.props.locale, function (gs) {// eslint-disable-line no-new
        _this.googleService = gs;
        _this.autocompleteGoogle = _this.googleService.autocompleteGoogle;
        _this.autocompleteLocus = _this.googleService.autocompleteLocus;
        _this.getAutocompleteSuggestions = (0, _debounce2.default)(_this.getAutocompleteSuggestions, 500, { leading: false });

        if (_this.props.initialAddress) {
          _this.geocodeCountry(_this.props.initialAddress);
        }
      });
      if (_constants.storage.value.getItem(_this.props.isForeign ? 'lastSearchHistoryForeign' : 'lastSearchHistory')) {
        _this.setState({
          lastSearchHistory: JSON.parse(_constants.storage.value.getItem(_this.props.isForeign ? 'lastSearchHistoryForeign' : 'lastSearchHistory')) // eslint-disable-line
        });
      }
    };_this.




















    onFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus();
      }
      if (_this.state.value) {
        _this.getAutocompleteSuggestions(_this.state.value);
      }
      _this.setState({ autoFocus: true });
      event.target.select();
    };_this.

    onBlur = function (event) {
      if (_this.props.onBlur) {
        _this.props.onBlur();
      }
      if (_this.state.suggestions[0] && _this.state.autoFocus === true) {
        if (_this.state.lastSearchHistory[0] && event.target.value !== _this.state.lastSearchHistory[0].description) {
          _this.searchSelectedOption(_this.state.suggestions[0]);
        } else if (!_this.state.lastSearchHistory[0] && event.target.value !== _this.state.suggestions[0].description) {
          _this.searchSelectedOption(_this.state.suggestions[0]);
        }
      }
    };_this.

    onKeyDown = function (event) {
      if (event.keyCode === _constants.enterKey) {
        event.preventDefault();
        _this.setState({
          autoFocus: false,
          value: event.target.value });

      }
    };_this.

    getSuggestionValue = function (suggestion) {return suggestion ? suggestion.description : '';};_this.

    getAutocompleteSuggestions = function (newValue) {
      if (!_this.googleService) {return;}
      _this.autocompleteLocus(newValue, null, null, _this.props.locusSearchConfig).
      then(function (suggestions) {
        if (!suggestions.length) {
          _this.tryAutocompleteGoogle(newValue);
        } else {
          _this.setState({ suggestions: suggestions });
        }
      }).
      catch(function () {return _this.tryAutocompleteGoogle(newValue);});
    };_this.

    getInputValue = function (value) {
      _this.setState({ value: value }, function () {
        if (value.length === 0) {
          _this.props.clearInput();
          _this.setState({ suggestions: [] });
        }
      });
      if (value.trim().length > 0) {
        _this.getAutocompleteSuggestions(value);
      }
    };_this.

    geocodeCountry = function (address) {return _this.googleService.geocodeCountryByAddress(address).
      then(function (data) {
        _this.props.getInputData(data);
        var geocodedValue = (0, _extractLocalisedData2.default)(data, _this.props.locale) || {};
        var city_name = geocodedValue.city_name || '';
        var country_name = geocodedValue.country_name || '';
        var separator = city_name ? ', ' : '';
        _this.setState({ geocodedValue: '' + city_name + separator + country_name });
      });};_this.

    searchSelectedOption = function (obj) {
      _this.saveOnHistory(obj);
      _this.setState({ value: obj.description, autoFocus: false }, function () {
        var placeId = (0, _get2.default)(obj, 'place.extra.google_place_id') || obj.place_id;
        var geocode = obj.tags && obj.type !== 'country' ?
        _this.googleService.performGeocodeLocusByInnerBase(obj.tags, obj.address, obj.type) :
        _this.googleService.geocodeLocusViaGoogle(placeId);

        geocode.then(function (data) {
          _this.props.getInputData(data);
          if (_this.props.focusSearchNode) {
            _this.props.focusSearchNode.focus();
          }
        });
      });
      if (_this.props.isMobile) {
        setTimeout(function () {
          var inputElement = document.querySelector('.' + _this.props.className + ' input');
          if (inputElement && document.activeElement === inputElement) {
            inputElement.blur();
          }
        }, 0);
      }
    };_this.

    saveOnHistory = function (suggestion) {
      if (suggestion) {
        var suggestionIsUnique = true;
        _this.state.lastSearchHistory.forEach(function (item) {
          if (
          suggestion.id && item.id === suggestion.id ||
          suggestion.place_id && item.place_id === suggestion.place_id)
          {
            suggestionIsUnique = false;
          }
        });

        if (suggestionIsUnique) {
          suggestion.isSearchHistory = true;
          if (_this.state.lastSearchHistory.length < 5) {
            _this.state.lastSearchHistory.unshift(suggestion);
          } else {
            _this.state.lastSearchHistory.pop();
            _this.state.lastSearchHistory.unshift(suggestion);
          }
          _constants.storage.value.setItem(
          _this.props.isForeign ? 'lastSearchHistoryForeign' : 'lastSearchHistory',
          JSON.stringify(_this.state.lastSearchHistory));

        }
      }
    };_this.

    trackSearch = function (value) {
      (0, _analyticsManager.trackPage)('/search?cat=home&q=' + value);
    };_this.

    tryAutocompleteGoogle = function (newValue) {var _ref =
      _this.props.googleSearchConfig || {},types = _ref.types,options = _ref.options;

      var promise = _this.autocompleteGoogle(newValue, types, options);
      if (promise instanceof Promise) {
        promise.
        then(function (results) {
          _this.lastAutocompleteResult = results;
          _this.setState({ suggestions: results });
          _this.trackSearch(newValue);
        }).
        catch(function (err) {
          _this.googleService.handleError(err);
          _this.setState({
            suggestions: _this.lastAutocompleteResult ?
            _this.lastAutocompleteResult : _this.state.lastSearchHistory });

        });
      }
    };_this.trackSearch = (0, _debounce2.default)(_this.trackSearch.bind(_this), 1000);return _this;}HomePageLocationInput.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {var _this2 = this;var localeChanged = newProps.locale && newProps.locale !== this.props.locale;if (localeChanged) {delete global.google;new _googleService2.default(newProps.locale, function (gs) {// eslint-disable-line no-new
        _this2.googleService = gs;});}if (this.googleService && newProps.initialAddress && newProps.initialAddress !== this.props.initialAddress && !newProps.сlearInputLocation) {this.geocodeCountry(newProps.initialAddress);}if (!newProps.initialAddress && !!this.props.initialAddress) {this.setState({ geocodedValue: '' });}};HomePageLocationInput.prototype.
  render = function render() {
    return (
      _react2.default.createElement(_OMAutocompleteInput2.default, {
        theme: _constants.inputStyleTheme,
        сlearInputLocation: this.props.сlearInputLocation,
        placeholder: this.props.placeholder,
        getInputValue: this.getInputValue,
        suggestions: this.state.suggestions.length > 0 ? this.state.suggestions : this.state.lastSearchHistory,
        getSuggestionValue: this.getSuggestionValue,
        selectedSuggestion: this.searchSelectedOption,
        shouldRenderSuggestions: function shouldRenderSuggestions() {return true;},
        onBlur: this.onBlur,
        onFocus: this.onFocus,
        onKeyDown: this.onKeyDown,
        onChange: this.onChange,
        deferRequestBy: 300,
        autoFocus: this.state.autoFocus,
        isMobile: this.props.isMobile,
        initialValue: this.props.locationValue || this.state.geocodedValue,
        isValid: true,
        isDeferredBlur: true,
        clearable: this.props.clearable,
        clearInput: this.props.clearInput,
        className: this.props.className }));


  };return HomePageLocationInput;}(_react.Component);


HomePageLocationInput.propTypes = {
  placeholder: _propTypes2.default.string,
  locale: _propTypes2.default.string.isRequired,
  getInputData: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  focusSearchNode: _propTypes2.default.object,
  locationValue: _propTypes2.default.string,
  clearInput: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  clearable: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  googleSearchConfig: _propTypes2.default.object,
  locusSearchConfig: _propTypes2.default.object,
  initialAddress: _propTypes2.default.string,
  isForeign: _propTypes2.default.bool,
  сlearInputLocation: _propTypes2.default.bool };exports.default =


HomePageLocationInput;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LocationInput/HomePageLocationInput/HomePageLocationInput.js
// module id = 2713
// module chunks = 0